import Section from "../components/Section";

const SummarySection = () => {
    return (
        <Section title="Summary">
            {/* <span>
                Engineering leader with 8 years building platforms and 5+ years
                managing teams, including building search and ranking systems
                from scratch. Co-founded 2 startups as CTO and led engineering
                at a third.
            </span> */}
            <span>
                Software engineer with a dual background in physics and CS, 7
                years of experience building and optimizing systems across
                simulation infrastructure (C++/CUDA, distributed computing, ML
                integration) and full-stack product development. Led teams of
                3-5 engineers across multiple companies and cofounded 2 startups
                as CTO. Combines deep technical depth in performance-critical
                systems with experience owning products end to end.
            </span>
        </Section>
    );
};

export default SummarySection;
